export enum UrlTarget {
  BLANK = '_blank',
  SELF = '_self',
}
